import React, { useState, useEffect, Fragment } from "react";
import { Col, Row, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { currentAccountSet } from "../../../actions/entities";
import { fetchGetAccounts } from "../../../services/api/accounts";
import { getPersonBankAccount } from "../../../services/api/accounts";
import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../../reducers/selectors";

import style from "./AccessConfigurationAccount.scss";

export const AccessConfigurationAccount = ({ toggle }) => {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [guaraniAccounts, setGuaraniAccounts] = useState([]);
  const [usdAccounts, setUsdAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const personInfo = useSelector(getSavedPersonInfo);

  useEffect(() => {
    if (personInfo) {
      setLoading(() => true);
      getPersonBankAccount({ accountId: 0 })
        .then(({ response }) => {
          setBankAccounts(response.personBankAccountInfo.BankAccounts);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(() => false);
        });
    }
  }, [personInfo]);

  useEffect(() => {
    let guaraniArray = [];
    let usdArray = [];
    bankAccounts.forEach((bankAccount) => {
      bankAccount.PersonBankAccountCurrency == "USD"
        ? usdArray.push(bankAccount)
        : guaraniArray.push(bankAccount);
    });
    setUsdAccounts(usdArray);
    setGuaraniAccounts(guaraniArray);
  }, [bankAccounts]);

  const AccountTable = (accounts) => {
    return (
      <Fragment>
        {accounts.accounts.map((account, index) => {
          return (
            <tr className={style.row} key={index}>
              <td className={`${style.td} ${style.currency}`}>
                {index === 0 ? (account.PersonBankAccountCurrency == "USD" ? "USD" : "Guaraníes") : null}
              </td>
              <td className={`${style.td} ${style.gray}`}>
                {account.PersonBankAccountType == "Current" ? "cuenta corriente" : "caja de ahorro"}
              </td>
              <td className={`${style.td} ${style.gray} ${style.accountNumber}`}>
                nº {account.PersonBankAccountNumber}
              </td>
              <td classsName={style.td}>
                <input type="radio" checked style={{ accentColor: "#EC7000" }} />
              </td>
            </tr>
          );
        })}
      </Fragment>
    );
  };

  return (
    <div className={style.account}>
      <div className={style.title}>
        tus cuentas <img className={style.logo} src="/img/logo-blue.png" alt="logo" />
        para operar con nosotros son:
      </div>

      <Row className={style.mainRow}>
        <Row className={style.innerRow}>
          <table className={style.table}>
            {loading ? <CircularProgress /> : null}
            {guaraniAccounts ? <AccountTable title="Guaraníes" accounts={guaraniAccounts} /> : null}
            {usdAccounts ? <AccountTable title="USD" accounts={usdAccounts} /> : null}
            {!guaraniAccounts && !usdAccounts && !loading ? "No hay cuentas de banco disponibles." : null}
          </table>
        </Row>
      </Row>

      <span className={style.confirmContainer}>
        <Button
          className={style.confirmButton}
          onClick={() => {
            toggle("suitability");
          }}
        >
          confirmar datos
        </Button>
      </span>
    </div>
  );
};
